import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { LangService } from "src/app/core/services/lang.service";
import { GridService } from "src/app/shared/services/grid.service";
import { DataLoadService } from "src/app/shared/services/data-load.service";

@Component({
  selector: "app-hr-com-shift-list",
  templateUrl:
    "./../../../templates/forms/modals/hr-com-shift-list.component.html"
})
export class HrComShiftComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "HrComShiftListid";

  dataObj: any;
  shiftList = [];
  public searchString;
  constructor(
    public langService: LangService,
    public gridService: GridService,
    private dataLoadService: DataLoadService
  ) {
    this.colObj = [
      {
        headerName: langService.langData.shiftId,
        field: "SHIFT_ID",
        sortable: true,
        resizable: true,
        hide: false
      },
      {
        headerName:langService.langData.shiftNo,
        field: "SHIFT_NO",
        sortable: true,
        resizable: true,
        hide: false
      }
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);

    this.dataLoadService.load("FG_HR_COMM_HR_SHIFT").subscribe(result => {
      this.shiftList = result.body;
    });
  }
  itemClick(_item) { 
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }
}
